import MediaBrowser from "./components/MediaBrowser";

export default function MediaManager() {
  return (
    <div data-testid="page-media">
      <h1>Media Manager</h1>
      <p className="hint">
        Store product boxes, screenshots and install ZIPs here. Each file gets a public URL
        (Copy URL) that your cart / other app can fetch. Product folders live under
        <code>products/&lt;slug&gt;</code>.
      </p>
      <div className="panel">
        <MediaBrowser />
      </div>
    </div>
  );
}
